module.exports = __webpack_public_path__ + "public/images/Illustration_Full_Curriculum_200x174.48becb5bfa36c2aacf1df28126738835.png";